/**
 * Section heading with eyebrow label + big display heading + optional intro.
 * Used across pages for consistent typography rhythm.
 */
export default function SectionHeading({ eyebrow, title, intro, align = "left", invert = false }) {
  const alignCls = align === "center" ? "text-center mx-auto items-center" : "text-left items-start";
  const titleCls = invert ? "text-[#F7F5F0]" : "text-[#1A1A1A]";
  const introCls = invert ? "text-[#C9C5BE]" : "text-[#5C5C5C]";
  const eyebrowCls = invert ? "text-[#C8102E]" : "text-[#C8102E]";
  return (
    <div className={`flex flex-col gap-5 max-w-3xl ${alignCls}`}>
      {eyebrow && (
        <span className={`text-[11px] font-semibold tracking-[0.28em] uppercase ${eyebrowCls}`}>
          {eyebrow}
        </span>
      )}
      <h2 className={`font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight uppercase ${titleCls}`}>
        {title}
      </h2>
      {intro && <p className={`text-base md:text-lg leading-relaxed max-w-2xl ${introCls}`}>{intro}</p>}
    </div>
  );
}
